/** Tab-übergreifende Navigation ohne Router: ManagementPage hört auf das
 *  Event, wechselt auf den Aufträge-Tab und öffnet die Akte des Auftrags. */
export const NAVIGIERE_AUFTRAG_EVENT = 'erp:navigiere-auftrag';

export interface NavigiereAuftragDetail {
  auftragId: number;
}

export function navigiereZuAuftrag(auftragId: number): void {
  window.dispatchEvent(
    new CustomEvent<NavigiereAuftragDetail>(NAVIGIERE_AUFTRAG_EVENT, { detail: { auftragId } })
  );
}

// Modul-weiter Flag statt Kontext/Prop-Drilling: die Chips, die
// navigiereZuAuftrag auslösen, sitzen in RegieberichtForm/-Overview, weit weg
// von ManagementPage. ManagementPage ist die einzige Instanz, die weiß, ob
// die aktuelle Rolle den Aufträge-Tab überhaupt sieht (sichtbareTabs) - und
// pflegt dieses Flag bei jeder Änderung nach (setAuftragNavigationVerfuegbar).
// Default true (optimistisch): ManagementPage ist immer die Wurzel, unter der
// diese Chips gerendert werden, ihr Effekt läuft also vor jedem relevanten
// Render - ein Default von false würde nur einen unnötigen Flackerer für die
// Mehrheit erzeugen, die navigieren darf.
let auftragNavigationVerfuegbar = true;

export function setAuftragNavigationVerfuegbar(verfuegbar: boolean): void {
  auftragNavigationVerfuegbar = verfuegbar;
}

/** Darf navigiereZuAuftrag() bei der aktuellen Rolle überhaupt etwas
 *  bewirken? Rollen ohne Aufträge-Tab (Projektleiter/Projektmitarbeiter/
 *  Buchhaltung) landen sonst auf dem Dashboard - die Chips blenden sich hier
 *  konsequent aus, statt tote Links anzuzeigen. */
export function kannZuAuftragNavigieren(): boolean {
  return auftragNavigationVerfuegbar;
}
